import defaultSettings from '@/settings'

const title = defaultSettings.title || '北汽重卡'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${title}`
  }
  return `${title}`
}
